(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.wof-card').forEach(function (card) {
      initCard(card);
    });
    document.querySelectorAll('.wof-referral__terms-toggle').forEach(function (btn) {
      initTerms(btn);
    });
  });

  function initCard(card) {
    const variantsRaw = card.dataset.variants;
    if (!variantsRaw) return;

    let variants;
    try { variants = JSON.parse(variantsRaw); } catch (e) { return; }

    const flavourBtns = card.querySelectorAll('.wof-card__flavour-btn');
    const flavourNote = card.querySelector('.wof-card__flavour-note');
    const priceEl     = card.querySelector('.wof-card__price');
    const compareEl   = card.querySelector('.wof-card__compare');
    const saveEl      = card.querySelector('.wof-card__save');
    const atcBtn      = card.querySelector('.wof-card__atc');

    let selectedOption1 = flavourBtns.length > 0 ? flavourBtns[0].dataset.value : null;

    function getVariant() {
      if (!selectedOption1) return variants[0] || null;
      return variants.find(function (v) { return v.option1 === selectedOption1; }) || variants[0];
    }

    const flavourQty = parseInt(card.dataset.flavourQty, 10) || 1;

    function formatNote(val) {
      if (!val) return '';
      /* If value starts with a digit e.g. "1 Chocolate & 1 Vanilla" → "1 × Chocolate & 1 × Vanilla" */
      if (/^\d/.test(val)) {
        return val.replace(/(\d+)\s+(?=\S)/g, '$1 × ');
      }
      /* Simple flavour name e.g. "Chocolate" → "2 × Chocolate" using card qty */
      return flavourQty + ' × ' + val;
    }

    function updatePrice(variant) {
      if (!variant) return;
      const priceCents   = variant.price;
      const compareCents = variant.compare_at_price || 0;
      const priceStr     = '$' + (priceCents / 100).toFixed(2);

      if (priceEl) priceEl.textContent = priceStr;

      if (compareEl) {
        if (compareCents > priceCents) {
          compareEl.textContent = 'Total value $' + (compareCents / 100).toFixed(2);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      if (saveEl) {
        if (compareCents > priceCents) {
          saveEl.textContent = 'Save $' + ((compareCents - priceCents) / 100).toFixed(2);
          saveEl.style.display = '';
        } else {
          saveEl.style.display = 'none';
        }
      }

      if (atcBtn) {
        atcBtn.dataset.variantId = variant.id;
        const label = atcBtn.dataset.label || 'Add to cart';
        atcBtn.textContent = label + ' — ' + priceStr;
        atcBtn.disabled = !variant.available;
        if (!variant.available) atcBtn.textContent = 'Sold out';
      }
    }

    function updateImage(variant) {
      if (!variant || !variant.image) return;
      const img = card.querySelector('.wof-card__img-wrap img');
      if (img && variant.image) {
        img.src = variant.image;
      }
    }

    function selectFlavour(btn) {
      flavourBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      selectedOption1 = btn.dataset.value;
      if (flavourNote) flavourNote.textContent = formatNote(btn.dataset.value);
      const variant = getVariant();
      updatePrice(variant);
      updateImage(variant);
    }

    flavourBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { selectFlavour(btn); });
    });

    // Init
    if (flavourBtns.length > 0) {
      flavourBtns[0].classList.add('is-active');
      if (flavourNote) flavourNote.textContent = formatNote(flavourBtns[0].dataset.value);
    }
    updatePrice(getVariant());

    // Add to cart
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        const variantId = atcBtn.dataset.variantId;
        if (!variantId || atcBtn.disabled) return;

        atcBtn.classList.add('is-loading');
        atcBtn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
        .then(function (res) { return res.json(); })
        .then(function (product) {
          atcBtn.classList.remove('is-loading');
          updatePrice(getVariant());
          // Trigger Impulse theme cart drawer (buildCart + open)
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: product },
            bubbles: true
          }));
        })
        .catch(function () {
          atcBtn.classList.remove('is-loading');
          updatePrice(getVariant());
        });
      });
    }
  }

  function initTerms(btn) {
    const body = btn.closest('.wof-referral__content').querySelector('.wof-referral__terms-body');
    if (!body) return;
    btn.addEventListener('click', function () {
      const open = body.classList.toggle('is-open');
      btn.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
})();
